import * as CryptoJS from 'crypto-js';

const secretKey = 'AÇ8ak9a8a7af9a57@#5afGg1%$4¨!!5QerqeQ%%$qtqtyeyrQYqery';

export function encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, secretKey).toString();
}

export function decrypt(textToDecrypt: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, secretKey).toString(CryptoJS.enc.Utf8);
}